import styled from 'styled-components';

export const ReporterDetailsContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ReporterDetailsInputFieldContainerStyled = styled.div`
  display: inline-block;
  width: 100%;
`;

export const ReporterNotesFieldContainerStyled = styled.div`
  display: inline-block;
  width: 100%;
`;

export const ReporterDetailsFieldsContainerStyled = styled.div`
  margin-bottom: 20px;
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

export const ReporterDetailsInnerContainerStyled = styled.div`
  padding: 20px;
`;
